import { render, staticRenderFns } from "./CamTop.vue?vue&type=template&id=38fc9ba8&"
import script from "./CamTop.vue?vue&type=script&lang=js&"
export * from "./CamTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports